import React, { Fragment } from 'react';
import { Row, Col, Table } from 'reactstrap';
import { formattedDateOnly } from '../../../../../utilities/formatedDate';


const CashifyPolicyUserDetails = ({ data }) => {

    return (
        <Fragment>
            <Row className='mt-4'>
                <Col sm="12" >
                 <Table>
                       <tbody>
                           {/* Customer Identification */}
                           <tr>
                               <th>Customer Name</th>
                               <td className="text-right pr-5">
                                   {data.customer.name ? data.customer.name : '-'}
                               </td>
                           </tr>
                           <tr>
                               <th>Email</th>
                               <td className="text-right pr-5">
                                   {data.customer.email ? data.customer.email : '-'}
                               </td>
                           </tr>
                           <tr>
                               <th>Phone Number</th>
                               <td className="text-right pr-5">
                                   {data.customer.phone_no ? data.customer.phone_no : '-'}
                               </td>
                           </tr>
               
                           {/* Customer Address Details */}
                           <tr>
                               <th>Address</th>
                               <td className="text-right pr-5">
                                   {/* Note: Property name is 'Address' with capital A in your JSON */}
                                   {data.customer.Address ? data.customer.Address : '-'}
                               </td>
                           </tr>
                           <tr>
                               <th>City</th>
                               <td className="text-right pr-5">
                                   {data.customer.city ? data.customer.city : '-'}
                               </td>
                           </tr>
                           <tr>
                               <th>State</th>
                               <td className="text-right pr-5">
                                   {data.customer.state ? data.customer.state : '-'}
                               </td>
                           </tr>
                           <tr>
                               <th>Pincode</th>
                               <td className="text-right pr-5">
                                   {data.customer.pin_code ? data.customer.pin_code : '-'}
                               </td>
                           </tr>
                           <tr>
                               <th>Country</th>
                               <td className="text-right pr-5">
                                   {data.customer.country ? data.customer.country : '-'}
                               </td>
                           </tr>
               
                           {/* Optional: Other Identifiers if needed */}
                           {/* <tr>
                               <th>GST Number</th>
                               <td className="text-right pr-5">
                                   {data.customer.gst_no ? data.customer.gst_no : '-'}
                               </td>
                           </tr> */}
                           {/* <tr>
                               <th>PAN Number</th>
                               <td className="text-right pr-5">
                                   {data.customer.pan_no ? data.customer.pan_no : '-'}
                               </td>
                           </tr> */}
                            {/* <tr>
                               <th>Customer ID</th>
                               <td className="text-right pr-5">
                                   {data.customer.user_id ? data.customer.user_id : '-'}
                               </td>
                           </tr> */}
               
                       </tbody>
                   </Table>
                </Col>
            </Row>
        </Fragment>
    );
};

export default CashifyPolicyUserDetails;